import { InjectionToken } from '@angular/core';
import { environment } from './environment';
import { AppVersion } from 'src/app/shared/services/version-checker.service';
import { SignalStoreFeature } from '@ngrx/signals';
import { EmptyFeatureResult, SignalStoreFeatureResult } from '@ngrx/signals/src/signal-store-models';

export interface Environment {
    production: boolean;
    appVersion: AppVersion;
    storeWithDevTools?: <Input extends SignalStoreFeatureResult>(
        name: string
    ) => SignalStoreFeature<Input, EmptyFeatureResult>;
}

export const ENV = new InjectionToken<Environment>('env');

export function getEnv(): Environment {
    return environment;
}
